var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"canvas",staticClass:"map-canvas",attrs:{"width":_vm.width,"height":_vm.height},on:{"mousedown":_vm.handleMouseDown,"mousemove":_vm.handleMouseMove}})}
var staticRenderFns = []

export { render, staticRenderFns }